<template>
  <div class="mb-6">
    <v-card color="white" class="px-10 py-6 mb-7">
      <v-skeleton-loader type="text" width="250" />
      <div class="d-flex mt-4">
        <v-skeleton-loader type="heading" width="100" />
        <v-skeleton-loader type="heading" width="100" />
        <v-skeleton-loader type="heading" width="100" />
      </div>
    </v-card>
    <v-row class="">
      <v-col cols="12" sm="4">
        <v-card class="px-10 py-6">
          <v-skeleton-loader type="text" width="60" class="mb-6" />
          <v-skeleton-loader type="text" width="30" />
          <v-skeleton-loader type="card" height="100" class="mb-4" />
          <v-skeleton-loader type="card" height="100" class="mb-4" />
          <v-skeleton-loader type="card" height="100" class="mb-6" />
          <v-skeleton-loader type="text" width="30" />
          <v-skeleton-loader type="card" height="100" class="mb-4" />
          <v-skeleton-loader type="text" width="30" />
          <v-skeleton-loader type="heading" class="mb-4" />
        </v-card>
      </v-col>
      <v-col cols="12" sm="8">
        <v-card class="px-10 py-6">
          <v-skeleton-loader type="text" width="60" class="mb-6" />
          <v-skeleton-loader type="text" width="30" />
          <v-skeleton-loader type="card" height="100" class="mb-4" />
          <v-skeleton-loader type="card" height="100" class="mb-4" />
          <v-skeleton-loader type="card" height="100" class="mb-6" />
          <v-skeleton-loader type="text" width="30" />
          <v-skeleton-loader type="card" height="100" class="mb-4" />
          <v-skeleton-loader type="text" width="30" />
          <v-skeleton-loader type="heading" class="mb-4" />
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  name: 'LoadingMode',
}
</script>
